import React, { useEffect } from 'react'
import { OverviewExpandableSectionProps } from './OverviewExpandableSection.types'
import styles from './OverviewExpandableSection.module.scss'
import { EventsPeriodChart } from 'components/charts'
import { inject } from 'mobx-react'
import {
  STATISTICS_OVERVIEW_BAR_CHART_STORE
} from 'store'
import { EventsDoughnut } from '../EventsDoughnut'
import { observer } from 'mobx-react-lite'
import { ExpandableBarChart } from 'pages/statistics/common'
import cl from 'classnames'

const OverviewExpandableSectionComponent = (props: OverviewExpandableSectionProps) => {
  const {
    className,
    style,
    initialIsExpandedState,
    [STATISTICS_OVERVIEW_BAR_CHART_STORE]: {
      // selectedTab,
      // isByExpensesTabSelected,
      getEventsPeriodStats,
      chartHeaderProps
    }
  } = props

  useEffect(() => {
    getEventsPeriodStats()
  }, [getEventsPeriodStats])

  return (
    <ExpandableBarChart
      className={cl(styles.container, className)}
      style={style}
      chartHeaderProps={chartHeaderProps}
      initialChartVisibility={initialIsExpandedState}
    >
      <EventsDoughnut />
      <div className={styles.verticalLine} />
      <EventsPeriodChart />
    </ExpandableBarChart>
  )
}

const OverviewExpandableSection = inject(
  STATISTICS_OVERVIEW_BAR_CHART_STORE
)(observer(OverviewExpandableSectionComponent))
export { OverviewExpandableSection }
